import { page } from "../page-copy";
import { revealHostProps } from "../reveal-host";
import { Link } from "../router";

/** Roadmap + invite to help — sits above the signup close. */
export default function WhatsNext({ delay }: { delay: number }) {
  const { next } = page;
  const reveal = revealHostProps(delay);
  const [line1, line2] = next.paragraphs[0].split("\n");
  return (
    <div
      className={`${reveal.className} next`}
      style={reveal.style}
      onAnimationEnd={reveal.onAnimationEnd}
    >
      <h2 className="next-heading">{next.heading}</h2>
      <p className="next-p">
        {line1}
        <br />
        {line2}
      </p>
      <p className="next-contact">{next.contact}</p>
      <p className="next-contact next-more">
        Want to dig deeper?{" "}
        <Link className="next-link" href="/philosophy">
          Read the JetShake philosophy
        </Link>{" "}
        - why the compiler exists, a more technical deep dive.
      </p>
    </div>
  );
}
